import type * as Schema from 'src/types/graphql';

export const groupLocations = (
  locations: Schema.Location2[],
  supportedCountries: Schema.CountryInformation[],
): Record<string, Schema.Location2[]> => {
  const groupedLocationsByCountry: Record<string, Schema.Location2[]> = {};
  supportedCountries.forEach((supportedCountry) => {
    groupedLocationsByCountry[supportedCountry.countryCode] = [];
  });

  groupedLocationsByCountry.Other = [];
  locations.forEach((location) => {
    if (groupedLocationsByCountry[location.countryCode]) {
      groupedLocationsByCountry[location.countryCode].push(location);
    } else {
      groupedLocationsByCountry.Other.push(location);
    }
  });

  return groupedLocationsByCountry;
};

export const removeLocationFromList = (
  { id }: Schema.Location2,
  locations: Schema.Location2[],
): Schema.Location2[] => locations.filter((location) => location.id !== id);
